import fromCamelToKebab from 'utils/converters/string/fromCamelToKebab.util';
import transformObject from 'utils/objects/transformObject.util';

const convert = (entries) => entries.map(([k, v]) => [`data-${fromCamelToKebab(k)}`, String(v)]);

const fromObjectToDataAttributes = (object) => transformObject(convert, object ?? {});

export default fromObjectToDataAttributes;
